import { render } from "./FilterSentiment.vue?vue&type=template&id=94e4357a&scoped=true"
import script from "./FilterSentiment.vue?vue&type=script&lang=js"
export * from "./FilterSentiment.vue?vue&type=script&lang=js"

import "./FilterSentiment.vue?vue&type=style&index=0&id=94e4357a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e4357a"]])

export default __exports__